<template>
  <div class="tabs-bar">
    <div class="tabs-scroll">
      <div
        v-for="tab in visitedTabs"
        :key="tab.path"
        class="tab-item"
        :class="{ active: isActive(tab) }"
        @click="clickTab(tab)"
        @contextmenu.prevent="openContextMenu($event, tab)"
      >
        <span class="tab-dot" v-if="isActive(tab)"></span>
        <span class="tab-title">{{ tab.title }}</span>
        <span
          class="el-icon-close tab-close"
          @click.stop="closeTab(tab)"
          v-if="tab.path !== '/welcome'"
        ></span>
      </div>
    </div>
    
    <div class="tabs-toolbar">
      <el-dropdown @command="handleCommand" trigger="click">
        <span class="toolbar-btn">
          <i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="tabs-dropdown">
          <el-dropdown-item command="refresh">
            <i class="el-icon-refresh"></i> 刷新当前
          </el-dropdown-item>
          <el-dropdown-item command="closeOther">
            <i class="el-icon-close"></i> 关闭其他
          </el-dropdown-item>
          <el-dropdown-item command="closeRight">
            <i class="el-icon-d-arrow-right"></i> 关闭右侧
          </el-dropdown-item>
          <el-dropdown-item command="closeAll" divided>
            <i class="el-icon-circle-close"></i> 关闭全部
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <ul
      v-show="contextMenuVisible"
      :style="{ left: contextMenuLeft + 'px', top: contextMenuTop + 'px' }"
      class="context-menu"
    >
      <li @click="refreshTab">
        <i class="el-icon-refresh"></i> 刷新
      </li>
      <li @click="closeSelectedTab" v-if="selectedTab && selectedTab.path !== '/welcome'">
        <i class="el-icon-close"></i> 关闭
      </li>
      <li @click="closeOtherTabs">
        <i class="el-icon-close"></i> 关闭其他
      </li>
      <li @click="closeRightTabs">
        <i class="el-icon-d-arrow-right"></i> 关闭右侧
      </li>
    </ul>
  </div>
</template>

<script>
import tabs from '@/utils/tabs'

export default {
  name: 'TabsBar',
  data() {
    return {
      contextMenuVisible: false,
      contextMenuLeft: 0,
      contextMenuTop: 0,
      selectedTab: null
    }
  },
  computed: {
    visitedTabs() {
      return tabs.visitedTabs
    },
    activeTab() {
      return tabs.activeTab
    }
  },
  watch: {
    $route: {
      handler(route) {
        tabs.addTab(route)
      },
      immediate: true
    }
  },
  methods: {
    isActive(tab) {
      return tab.path === this.activeTab
    },
    clickTab(tab) {
      if (tab.path !== this.activeTab) {
        tabs.setActiveTab(tab.path)
        this.$router.push(tab.path)
      }
    },
    closeTab(tab) {
      tabs.closeTab(tab.path, this.$router)
    },
    handleCommand(command) {
      switch (command) {
        case 'refresh':
          this.refreshTab()
          break
        case 'closeOther':
          this.closeOtherTabs()
          break
        case 'closeRight':
          this.closeRightTabs()
          break
        case 'closeAll':
          tabs.closeAllTabs(this.$router)
          break
      }
    },
    openContextMenu(e, tab) {
      this.selectedTab = tab
      this.contextMenuLeft = e.clientX
      this.contextMenuTop = e.clientY
      this.contextMenuVisible = true
    },
    closeContextMenu() {
      this.contextMenuVisible = false
      this.selectedTab = null
    },
    refreshTab() {
      this.closeContextMenu()
      this.$emit('refresh')
    },
    closeSelectedTab() {
      if (this.selectedTab) {
        tabs.closeTab(this.selectedTab.path, this.$router)
      }
      this.closeContextMenu()
    },
    closeOtherTabs() {
      if (this.selectedTab) {
        tabs.closeOtherTabs(this.selectedTab.path)
        if (this.selectedTab.path !== this.activeTab) {
          this.$router.push(this.selectedTab.path)
        }
      }
      this.closeContextMenu()
    },
    closeRightTabs() {
      if (this.selectedTab) {
        tabs.closeRightTabs(this.selectedTab.path)
      }
      this.closeContextMenu()
    }
  },
  mounted() {
    document.addEventListener('click', this.closeContextMenu)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeContextMenu)
  }
}
</script>

<style scoped>
.tabs-bar {
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  padding: 0 12px;
  height: 40px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  position: relative;
}

.tabs-scroll {
  flex: 1;
  display: flex;
  align-items: center;
  overflow-x: auto;
  white-space: nowrap;
  gap: 4px;
}

.tabs-scroll::-webkit-scrollbar {
  height: 0;
}

.tab-item {
  display: inline-flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  padding: 0 12px;
  border-radius: 4px;
  background: #fafafa;
  cursor: pointer;
  font-size: 13px;
  color: #595959;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  flex-shrink: 0;
}

.tab-item:hover {
  background: #e6f7e6;
  color: #3CA757;
}

.tab-item.active {
  background: linear-gradient(135deg, #3CA757 0%, #2d8a47 100%);
  color: #fff;
  border-color: transparent;
  box-shadow: 0 2px 4px rgba(60, 167, 87, 0.3);
}

.tab-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
  margin-right: 6px;
  flex-shrink: 0;
}

.tab-title {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tab-close {
  margin-left: 6px;
  font-size: 12px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  opacity: 0;
}

.tab-item:hover .tab-close {
  opacity: 1;
}

.tab-item.active .tab-close {
  opacity: 0.8;
}

.tab-close:hover {
  background: rgba(0, 0, 0, 0.1);
}

.tab-item.active .tab-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.tabs-toolbar {
  margin-left: 12px;
  padding-left: 12px;
  border-left: 1px solid #e8e8e8;
}

.toolbar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  color: #8c8c8c;
}

.toolbar-btn:hover {
  background: #f5f5f5;
  color: #3CA757;
}

.context-menu {
  position: fixed;
  z-index: 3000;
  list-style: none;
  margin: 0;
  padding: 4px 0;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  font-size: 13px;
  min-width: 120px;
}

.context-menu li {
  padding: 8px 16px;
  cursor: pointer;
  color: #595959;
  display: flex;
  align-items: center;
  transition: all 0.2s;
}

.context-menu li:hover {
  background: #e6f7e6;
  color: #3CA757;
}

.context-menu li i {
  margin-right: 8px;
  font-size: 14px;
}
</style>

<style>
.tabs-dropdown {
  margin-top: 4px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  padding: 4px 0;
}

.tabs-dropdown .el-dropdown-menu__item {
  padding: 8px 16px;
  font-size: 13px;
  color: #595959;
}

.tabs-dropdown .el-dropdown-menu__item:hover {
  background: #e6f7e6;
  color: #3CA757;
}

.tabs-dropdown .el-dropdown-menu__item i {
  margin-right: 8px;
}
</style>
